enum currencyType {
    PLN = 0,
    EU = 1000, 
}
export default currencyType;